import Card from '../Card';
import React from 'react';
import { isEmpty } from '../../../../util/isEmpty';

/**
 * Renders UI Cards
 * @param {array} data - the card data
 * @returns {*}
 */
export const renderCards = (data) => {
  return data.map(
    (item, i) =>
      !isEmpty(item) && (
        <Card
          key={`card-${i}`}
          tags={item?.tags}
          company={item?.company}
          date={item?.date}
          type={item?.type}
          logo={item?.logo}
          title={item?.title}
          excerpt={item?.excerpt}
          link={item?.link}
          backgroundColor={item?.backgroundColor}
          isFeatured={item?.isFeatured}
          isRecentNews={item?.isRecentNews}
          isSearch={item?.isSearch}
          hoverImage={item?.hoverImage}
          quote={item?.quote}
          quoteAuthor={item?.quoteAuthor}
          logos={item?.logos}
          industry={item?.industry}
        />
      ),
  );
};
